"use client"

import { Navigate } from "react-router"

import { useExamRole } from "@/contexts/exam-role-context"
import {
  EXAM_MANAGEMENT_ADMIN_HOME_PATH,
  EXAM_MANAGEMENT_MY_EXAMS_PATH,
} from "@/lib/exam-management-paths"

/** Role-aware default when opening Exam Management (index or `/dashboard`). */
export function ExamManagementLanding() {
  const { role } = useExamRole()
  if (role === "Student") {
    return <Navigate to={EXAM_MANAGEMENT_MY_EXAMS_PATH} replace />
  }
  return <Navigate to={EXAM_MANAGEMENT_ADMIN_HOME_PATH} replace />
}
